import { useRef } from 'react';
function useTitle(title) {
    var t = useRef();
    if (t.current !== title) {
        document.title = t.current = title;
    }
}
export default typeof document !== 'undefined' ? useTitle : function (_title) { };
